//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageHeader from '@/components/PageHeader.vue'
import UserPublicAvatar from '@/components/users/UserPublicAvatar.vue'
import { authorContributionTotal, authorProfilePath, authorRowDisplayName } from '@/utils/userPublic.js'

const CATEGORIES_LIMIT = 3
const AUTHORS_LIMIT_STEP = 20

const columns = [
  {
    title: '',
    dataIndex: 'avatar',
    key: 'avatar',
    scopedSlots: { customRender: 'avatar' },
    width: 72,
  },
  {
    title: 'Автор',
    dataIndex: 'author',
    key: 'author',
    scopedSlots: { customRender: 'author' },
  },
  {
    title: 'Вклад',
    dataIndex: 'contribution',
    key: 'contribution',
    scopedSlots: { customRender: 'contribution' },
    width: 150,
  },
  {
    title: 'Комментарии',
    dataIndex: 'comments_total',
    key: 'comments_total',
    scopedSlots: { customRender: 'comments_total' },
    width: 130,
    align: 'right',
  },
  {
    title: 'Темы',
    dataIndex: 'categories',
    key: 'categories',
    scopedSlots: { customRender: 'categories' },
    align: 'left',
  },
]

function categoryId(row) {
  return row.category_id ?? row.object_category_id ?? row.most_freq_category_id ?? row.id
}

function categoryLabel(row) {
  return row.category_label || row.category_name || row.object_category_label || row.most_freq_category_name || row.label || row.name || ''
}

function categorySlug(row) {
  return row.category_url || row.category_slug || row.object_category_url || row.most_freq_category_url || row.url || row.slug || ''
}

function flattenCategoryTree(tree, result = {}) {
  ;(tree || []).forEach((item) => {
    const node = item?.node || item
    if (node && node.id) {
      result[String(node.id)] = node
    }
    if (Array.isArray(item?.items)) {
      flattenCategoryTree(item.items, result)
    }
  })
  return result
}

function normalizeCategory(row, categoriesById = {}) {
  const id = categoryId(row)
  const categoryFromTree = id != null ? categoriesById[String(id)] : null
  const label = categoryLabel(row) || categoryFromTree?.label || ''
  const slug = categorySlug(row) || categoryFromTree?.url || categoryFromTree?.slug || ''
  if (!id && !label && !slug) return null

  return {
    id,
    label: label || slug || String(id),
    slug,
    key: String(id || slug || label),
    total: authorContributionTotal(row),
  }
}

function withAuthorCategories(authors, categoryRows, categoriesById) {
  const byAuthor = new Map()
  ;(categoryRows || []).forEach((row) => {
    if (!row || !row.author_id) return
    const category = normalizeCategory(row, categoriesById)
    if (!category) return

    const authorKey = String(row.author_id)
    if (!byAuthor.has(authorKey)) byAuthor.set(authorKey, new Map())

    const categories = byAuthor.get(authorKey)
    const current = categories.get(category.key)
    if (!current || category.total > current.total) {
      categories.set(category.key, category)
    }
  })

  return authors.map((author) => {
    const categoriesMap = byAuthor.get(String(author.author_id))
    const categories = categoriesMap
      ? [...categoriesMap.values()].sort((a, b) => b.total - a.total || a.label.localeCompare(b.label, 'ru'))
      : []

    return {
      ...author,
      categories,
    }
  })
}

function authorMaterialsTotal(row) {
  return (Number(row?.articles_total) || 0) + (Number(row?.encyclopedia_total) || 0)
}

function authorCommentsTotal(row) {
  return normalizeCommentTotal(row) ?? 0
}

function compareAuthors(a, b) {
  const materialsA = authorMaterialsTotal(a)
  const materialsB = authorMaterialsTotal(b)
  const commentsA = authorCommentsTotal(a)
  const commentsB = authorCommentsTotal(b)

  if (materialsA || materialsB) {
    return materialsB - materialsA || commentsB - commentsA
  }

  return commentsB - commentsA
}

function normalizeCommentTotal(row) {
  const value = row?.comments_total
    ?? row?.comments_count
    ?? row?.comment_total
    ?? row?.comment_count
    ?? row?.total_comments
  const number = Number(value)
  return Number.isFinite(number) ? number : null
}

function responseTotal(response) {
  if (Array.isArray(response)) return response.length
  const value = response?.total ?? response?.count ?? response?.items?.length
  const number = Number(value)
  return Number.isFinite(number) ? number : 0
}

export default {
  name: 'UsersPublicList',
  components: { PageHeader, UserPublicAvatar },
  layout: 'public_new',
  async asyncData({ store }) {
    const [authorsResponse, categoryAuthorsResponse, categoryTree] = await Promise.all([
      store.dispatch('users/fetchPublicAuthorsTable', { limit: 1000, offset: 0, exclude_zero: false }),
      store.dispatch('users/fetchPublicCategoryAuthorsTable', { limit: 5000, offset: 0 }).catch(() => ({ items: [] })),
      store.dispatch('categories/getNavTreeDetail').catch(() => []),
    ])
    const rows = authorsResponse.items || []
    const categoriesById = flattenCategoryTree(categoryTree)
    const authors = await store.dispatch(
      'users/enrichAuthorsWithProfiles',
      withAuthorCategories(
        rows
          .sort(compareAuthors),
        categoryAuthorsResponse.items || [],
        categoriesById
      )
    )

    return {
      authors,
      columns,
      CATEGORIES_LIMIT,
      AUTHORS_LIMIT_STEP,
    }
  },
  data() {
    return {
      authors: [],
      columns,
      CATEGORIES_LIMIT,
      AUTHORS_LIMIT_STEP,
      visibleAuthorsLimit: AUTHORS_LIMIT_STEP,
      expandedCategoryAuthors: {},
      commentsByAuthor: {},
      loadingCommentAuthors: {},
      loading: false,
    }
  },
  head() {
    return {
      title: 'Все авторы',
    }
  },
  computed: {
    sortedAuthors() {
      return [...this.authors]
        .filter(this.hasResolvedPublicActivity)
        .sort(this.compareResolvedAuthors)
    },
    visibleAuthors() {
      return this.sortedAuthors.slice(0, this.visibleAuthorsLimit)
    },
  },
  mounted() {
    this.loadCommentOnlyAuthorCounts()
    this.loadVisibleCommentCounts()
  },
  methods: {
    authorDisplayName: authorRowDisplayName,
    authorProfilePath,
    authorCommentCount(record) {
      const authorId = record?.author_id
      if (authorId != null && this.commentsByAuthor[String(authorId)] != null) {
        return this.commentsByAuthor[String(authorId)]
      }
      return normalizeCommentTotal(record) ?? 0
    },
    hasResolvedPublicActivity(record) {
      if (authorMaterialsTotal(record) > 0) return true

      const authorId = record?.author_id
      const key = authorId != null ? String(authorId) : null
      const initialCommentTotal = normalizeCommentTotal(record)

      if (key && this.commentsByAuthor[key] != null) {
        return this.commentsByAuthor[key] > 0
      }

      return initialCommentTotal == null || initialCommentTotal > 0
    },
    compareResolvedAuthors(a, b) {
      const materialsA = authorMaterialsTotal(a)
      const materialsB = authorMaterialsTotal(b)
      const commentsA = this.authorCommentCount(a)
      const commentsB = this.authorCommentCount(b)

      if (materialsA || materialsB) {
        return materialsB - materialsA || commentsB - commentsA
      }

      return commentsB - commentsA
    },
    isCommentCountLoading(record) {
      const authorId = record?.author_id
      return Boolean(authorId != null && this.loadingCommentAuthors[String(authorId)])
    },
    shouldLoadCommentCount(record) {
      const authorId = record?.author_id
      if (authorId == null) return false

      const key = String(authorId)
      if (this.commentsByAuthor[key] != null || this.loadingCommentAuthors[key]) return false

      const commentTotal = normalizeCommentTotal(record)
      return commentTotal == null || commentTotal === 0
    },
    loadVisibleCommentCounts() {
      const authors = this.visibleAuthors.filter(this.shouldLoadCommentCount)
      authors.forEach((record) => {
        this.loadAuthorCommentCount(record.author_id)
      })
    },
    loadCommentOnlyAuthorCounts() {
      this.authors
        .filter((record) => authorMaterialsTotal(record) === 0)
        .filter(this.shouldLoadCommentCount)
        .forEach((record) => {
          this.loadAuthorCommentCount(record.author_id)
        })
    },
    async loadAuthorCommentCount(authorId) {
      const key = String(authorId)
      this.$set(this.loadingCommentAuthors, key, true)
      try {
        const response = await this.$store.dispatch('art/publicUserComments', { id: authorId })
        this.$set(this.commentsByAuthor, key, responseTotal(response))
      } catch (e) {
        this.$set(this.commentsByAuthor, key, 0)
      } finally {
        this.$set(this.loadingCommentAuthors, key, false)
      }
    },
    visibleCategories(record) {
      const categories = record.categories || []
      if (this.expandedCategoryAuthors[record.author_id]) {
        return categories
      }
      return categories.slice(0, this.CATEGORIES_LIMIT)
    },
    toggleCategories(record) {
      this.$set(
        this.expandedCategoryAuthors,
        record.author_id,
        !this.expandedCategoryAuthors[record.author_id]
      )
    },
    categoryLink(category) {
      return category.slug ? `/s/${category.slug}` : `/objects?category=${category.id}`
    },
    showMoreAuthors() {
      this.visibleAuthorsLimit += this.AUTHORS_LIMIT_STEP
      this.$nextTick(() => {
        this.loadVisibleCommentCounts()
      })
    },
  },
}
